export const StationState = {
  ReadyToSpawn: 'readyToSpawn',
  WaitingForPickup: 'waitingForPickup',
  PickedUp: 'pickedUp'
} as const;
export type StationStateKeys = keyof typeof StationState;
export type StationStateValues = typeof StationState[StationStateKeys];

export class Station {
  protected state: StationStateValues;
  protected pickupPoint: number;
  protected chargeAmount: number;

  constructor(pickupPoint: number, chargeAmount: number) {
    this.state = StationState.ReadyToSpawn;

    this.pickupPoint = pickupPoint;
    this.chargeAmount = chargeAmount;
  }

  get State(): StationStateValues {
    return this.state;
  }

  get PickupPoint(): number {
    return this.pickupPoint;
  }

  get ChargeAmount(): number {
    return this.chargeAmount;
  }

  public spawned() {
    this.state = StationState.WaitingForPickup;
  }

  public pickedUp() {
    this.state = StationState.PickedUp;
  }
}
